export default "__VITE_ASSET__tkzm48iM__"